import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { PasswordChangeData } from 'Interfaces/Auth';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: PasswordChangeData) =>
    $actions.user.changePassword(dispatch, payload),
  );
};
